module.exports = __webpack_public_path__ + "static/media/SD_Scorecard.2445ccf2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/personnel/components/SD_Scorecard.pdf
// module id = 2808
// module chunks = 0